import React from 'react'
import "./TaskDescription.css";
import StarIcon from "@material-ui/icons/Star";

function Review({reviewId, customer,ratings,details }) {
  return (
    <div className="review__page">
    <div className="review__pageContainer">

    <div className="review__pageTop">
      <div className="review__strong">
        <strong>{ratings} </strong>     
      </div>
      <p>Great Service</p>
    </div>
    <div className="review__pageMiddle">
      <p>
        {details}
      </p>
    </div>
    <div className="review__pageBottom">
      <p>{customer}</p>
      <p>August 8</p>
    </div>
  </div>
  </div>
  )
}

export default Review